// Default selected values
export const DEFAULT_DOCUMENT_TYPE_ID = 1; // DNI
export const DEFAULT_DOCUMENT_TYPE_DESCRIPTION = 'dni';
export const DEFAULT_ROLE_ID = 20; // Operator
export const DEFAULT_ROLE_DESCRIPTION = 'operator.natura';

// Filter constants for API calls
export const ALLOWED_DOCUMENT_TYPE_IDS = [1, 9, 10];
export const DOCUMENT_TYPES_FILTER = `id in [${ALLOWED_DOCUMENT_TYPE_IDS.join(';')}]`;

// Platform and email type IDs used for user registration
export const PLATFORM_BACKOFFICE_ID = 11;
export const EMAIL_TYPE_BACKOFFICE_ID = 4;

// Person attribute keys
export const PERSON_ATTRIBUTE_FIRST_NAME = 'first_name';
export const PERSON_ATTRIBUTE_LAST_NAME = 'last_name';

// Alert configuration
export const ALERT_SUCCESS_CLASS = 'clientsMC_Alert--success';
export const ALERT_ERROR_CLASS = 'clientsMC_Alert--error';
export const ALERT_SEVERITY_SUCCESS = 'success';
export const ALERT_SEVERITY_ERROR = 'error';

// HTTP status codes
export const HTTP_BAD_REQUEST = 400;

// API error keys returned in e.response.data.error
export const ERROR_KEY_EMAIL_EXISTS = 'email';
export const ERROR_KEY_USER_EXISTS = 'user';

// Input validation
export const ONLY_NUMBERS_REGEX = /^\d*$/;
export const ONLY_LETTERS_REGEX = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]*$/;
export const DEFAULT_MAX_DOCUMENT_LENGTH = 8;
export const DEFAULT_MIN_DOCUMENT_LENGTH = 7;
export const MAX_DOCUMENT_LENGTH_BY_TYPE = {
    dni: 8,
    cpf: 11,
    ci_paraguay: 8,
};
export const MIN_DOCUMENT_LENGTH_BY_TYPE = {
    dni: 7,
    cpf: 11,
    ci_paraguay: 7,
};

// Form field keys
export const FORM_FIELDS = {
    DOCUMENT_TYPE: 'documentType',
    DOCUMENT: 'document',
    NAME: 'name',
    LAST_NAME: 'lastName',
    EMAIL: 'email',
    ROLE: 'role',
};

export const INITIAL_ERROR_STATE = {
    [FORM_FIELDS.DOCUMENT_TYPE]: '',
    [FORM_FIELDS.DOCUMENT]: '',
    [FORM_FIELDS.NAME]: '',
    [FORM_FIELDS.LAST_NAME]: '',
    [FORM_FIELDS.EMAIL]: '',
    [FORM_FIELDS.ROLE]: '',
};
